import React from 'react';
import styled from 'styled-components';
import InputLabelHint from '../InputLabelHint';
import { colors } from '../../../../assets/styles/colors';
import { fontSize } from '../../../../assets/styles/typography';
import { breakpoints, breakpointsForMaxWidth } from '../../../../assets/styles/grid';

const Row = styled.div`
  padding: 0;
  @media only screen and (max-width: ${breakpointsForMaxWidth.small}) {
    flex-wrap: wrap-reverse;
  }
`;

const Label = styled.label.attrs({ htmlFor: props => props.inputId })`
  font-size: ${fontSize.textSm};
  color: ${colors.grayDark};
  line-height: 36px;
  margin-bottom: 0;
  @media only screen and (max-width: ${breakpointsForMaxWidth.small}) {
    margin-left: 4px;
    margin-top: 8px;
    margin-bottom: 2px;
  }
`;

const Required = styled.span`
  margin-left: 4px;
  color: ${colors.required};
`;

const HintWrapper = styled.span`
  margin-left: 4px;
`;

const InputWrapper = styled.div`
  display: flex;
  @media only screen and (max-width: ${breakpointsForMaxWidth.small}) {
    padding-right: 0px;
  }
  @media only screen and (min-width: ${breakpoints.small}) {
    justify-content: flex-end;
    text-align: right;
  }
`;

const Error = styled.div`
  font-size: ${fontSize.textSm};
  color: ${colors.error};
`;

const Warning = styled.div`
  font-size: ${fontSize.textSm};
  color: ${colors.gray};
`;

export const InputFirstFormRow = props => {
  const {
    name,
    label,
    hint,
    required,
    error,
    warning,
    children,
    inputId,
    hidden,
    invisible,
    bottomMargin,
  } = props;
  return (
    <div className="w-100" hidden={hidden} style={{ visibility: invisible ? 'hidden' : 'visible' }}>
      <Row className="w-100 row mx-0">
        <InputWrapper className="col-12 col-sm-4 col-md-4 col-lg-3 d-flex pl-0">
          {children}
        </InputWrapper>
        <Label
          name={name}
          className="col-12 col-sm-8 col-md-8 col-lg-4 d-flex pl-1 pr-0"
          inputId={inputId}
        >
          {label}
          {hint && (
            <HintWrapper>
              <InputLabelHint hint={hint} />
            </HintWrapper>
          )}
          {required && <Required>*</Required>}
        </Label>
      </Row>
      <Row className="w-100 row mx-0">
        <div className="col-12 col-sm-4 col-md-4 col-lg-3 pl-0" />
        <div className="col-12 col-sm-8 col-md-8 col-lg-4 pl-2 pr-0">
          {error && <Error className="w-100 mt-1">{error}</Error>}
          {warning && (
            <Warning className="w-100 mt-1">
              <span>
                <i className="fas fa-exclamation-triangle fa-sm mr-1" />
                {warning}
              </span>
            </Warning>
          )}
        </div>
      </Row>
      {bottomMargin ? <div className="w-100 mb-2" /> : <></>}
    </div>
  );
};
